// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Label } from "@components";

import { ComboBox } from "@components";
import type { OptionType } from "@components";
import type { SpecialContactsType } from "@modules/service/reducer/special-contacts-types/types";

type Props = $Exact<{
  showEmptyOption: boolean,
  emptyOptionText: string,
  defaultValue: ?number,
  labelValue: ?string,
  types: Array<SpecialContactsType>,
  onChange: (value: number) => void,
  ...PropsFromLocalize,
}>;

type State = $Exact<{
  selected: ?number,
}>;

export class SpecialContactsTypeFilter extends React.Component<Props, State> {
  static defaultProps = {
    showEmptyOption: false,
    emptyOptionText: "ALL",
    defaultValue: undefined,
    labelValue: undefined,
  };

  state = {
    selected: this.props.defaultValue,
  };

  get typeOptions() {
    return this.props.types
      ? this.props.types.map((type: SpecialContactsType) => ({
          value: type.id,
          label: type.name,
        }))
      : [];
  }

  get options() {
    if (!this.props.showEmptyOption) {
      return this.typeOptions;
    }

    return [{ value: 0, label: this.props.t(this.props.emptyOptionText) }, ...this.typeOptions];
  }

  get selectedOption() {
    return this.options.find(option => option.value === this.props.defaultValue)?.value;
  }

  handleChange = (val: OptionType) => {
    this.props.onChange(val);
  };

  render() {
    return (
      <div>
        {this.props.labelValue && (
          <Label className="fs-14 text-color-charcoal">{this.props.t(this.props.labelValue)}</Label>
        )}
        <ComboBox options={this.options} value={this.selectedOption} onChange={this.handleChange} />
      </div>
    );
  }
}

export default localize()(SpecialContactsTypeFilter);
